import { Component } from '@angular/core';

import { TableCellBaseComponent } from '@wcg/frontend-framework';

@Component({
    selector: 'wcg-link-action-cell',
    imports: [],
    templateUrl: './link-action-cell.component.html',
    styleUrls: ['./link-action-cell.component.scss']
})
export class LinkActionCellComponent extends TableCellBaseComponent<any> {
  onProcessAction(event: Event): void {
    if (!this.componentConfig.readonly) {
      this.componentConfig.callback(
        this.componentConfig.rowData,
        'process_action',
        this.componentConfig.columnKey,
      );
    }
    event.stopPropagation();
  }
}
